<template>
  <div class="wrapper">
	   <headerTag />
       <div class="detailCon1">
		  <img src="../../assets/images/detail/dskfwb.png" alt=""  />
		  
	   </div>
	   <div class="detailCon1-div1 clear">
	   			  <p>
	   				  <span>电商客服外包</span>
	   				  <span v-if="productPrice=='my'">
	   				  		面议
	   				  </span>
	   				  <span v-else>
	   				  		￥{{productPrice}}
	   				  </span>
	   			  </p>
	   			  <p>        
	   				 专业团队在线，实时解决客户需求。
	   			  </p>
	    </div>
	  <div class="detailCon detailCon2">
		  <p class="detailCon2-tips" style="margin-top:0;">
		  	  业务类型
		  </p>
		  <p class="detailCon2-choose">
		  	  <span :class="{'cur': sqkf == '1'}" @click="typeChooseMore" typeNum="sqkf" style="width: 30%;margin-right: 5%;">售前客服</span>
		  	  <span :class="{'cur': shkf == '2'}" @click="typeChooseMore" typeNum="shkf" style="width: 30%;margin-right: 5%;">售后客服</span>
			  <span :class="{'cur': dhkf == '3'}" @click="typeChooseMore" typeNum="dhkf" style="width: 30%;margin-right: 0;">电话客服</span>
		  </p>
	  </div>
	  <div class="detailCon detailCon3">
	  	  <p class="detailCon2-tips" style="margin-top: 0;">
	  		 服务简介
	  	   </p>
		   <p>
			   
				专注电商客服外包，客服服务全程质检，网店服务质量高，客服7x24h在线。电商网店售前/售后/电话客服均可承接。金牌客服外包服务商。
				<br>客服外包对于企业来说是降低成本，以及快速扩张服务能量的好方法，能够降低营运成本，提高品质，集中人力资源，提高顾客满意度。
				<br>客服外包服务业是一种长期的、战略的、相互渗透的、互利双赢的业务委托和合约执行方式。
			                          				                    				
			</p>
	   </div>
	  <div class="detailCon detailCon4">
	   	  <p class="detailCon2-tips" style="margin-top: 0;">
	   		 服务流程
	   	   </p>
	   	   <p>
			   <span>
				   <img src="../../assets/images/detail/liucheng1.png" alt="" />
				   <i>咨询下单</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng2.png" alt="" />
			   		<i>提交材料</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng3.png" alt="" />
			   		<i>业务办理</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng4.png" alt="" />
			   		<i>售后服务</i>
			   </span>
		   </p>
	    </div>
	  <div class="detailCon detailCon5">
			  <p class="detailCon2-tips" style="margin-top: 0;">
				 所需材料
			   </p>
			  <div>
				  <p><i></i><span>公司经营类目的情况及日常客户服务说明</span></p>
				  <p><i></i><span>公司经营中所需的电商客服需求说明</span></p>
			  </div>
	  </div>
		
		<div class="detailBottom-box">
			<div class="detailBottom">
				<p @click="runQq()">
					<i>
						<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.23rem;" />
					</i>
					
					<span>QQ联系</span>
				</p>
				<p @click="runWx()">
					<i>
						<img src="../../assets/images/detail/weixin.png" alt="" style="height: 1rem;" />
					</i>
					<span>微信联系</span>
				</p>
				<p>
					<a :href="'tel:'+phoneNum">
						<i>
							<img src="../../assets/images/detail/phone.png" alt="" style="height: 0.92rem;" />
						</i>
						<span>电话联系</span>
					</a>
				</p>
				<button @click="buyThis" v-bind:disable="dis" :class="{'cur': dis == true}">{{buyBtn}}</button>
			</div>
		</div>
	 
		
		<van-popup v-model="wxShow" class="popDiv erDiv">
				<p>
					<span>扫码咨询</span>
					<img src="../../assets/images/detail/close.png" class="closeImg" @click="wxShow=false" />
				</p>
				<img :src="wxPic" class="erImg" />
				<p class="wxTitle">
					<i></i>
					<span>微信号</span>
					<i></i>
				</p>
				<p class="erNum" id="copyValue">{{wxNum}}</p>
				<p class="copyBtn">
					<button @click="copy" data-agl-cvt="32" id="copyTxt" data-clipboard-action="copy" data-clipboard-target="#copyValue">复制</button>
				</p>
				<p class="wxTips">扫一扫或复制微信号，添加好友咨询~</p>
		</van-popup>
   </div>
</template>

<script>
  import "../../assets/css/detail.scss"
  import headerTag from '@/components/headerTag/headerTag.vue'
  import { getProductDetail,getProv,getCity,getCustomerInfo,openConsult,nowBuyProduct } from '../../assets/js/common.js' 
  import { myMixin } from '../../mixins' 
  import { Popup,Picker } from 'vant'
  import Clipboard from 'clipboard'
 
  export default {
    name: 'productDskfwb',
	mixins:[myMixin],
	props:{
		
	},
	data(){
		return {
			bussFlag:25,
			isShow:0,
			businessType:'', //业务类型
			wxShow:false,//微信弹框
			dis:false, //立即购买按钮的disable
			buyBtn:'立即购买',
			sqkf:1,  //售前客服
			shkf:2, //售后客服
			dhkf:3, //电话客服
			businessType:[],
		}
	},
	components: {
       headerTag,
	   [Popup.name]:Popup,
	   [Picker.name]:Picker ,
     },
	 methods:{
		 buyThis(){
			let _this=this;
		 	if(this.pid == null || this.pid == "" ){
			  	_this.$message.error({message: "暂无产品，请咨询客服"});
			  	return;
		    }
		    _this.dis=true; // 不可点击
			nowBuyProduct(this.pid,function(data){
				_this.dis=false;
				if(data.code == 1000){
					//成功
					window.location.href='/order/paySure/'+data.obj;
				}else if(data.code == 1110){
					//未登录
					let currPath=window.location.href;
					window.location.href='/login?targetUrl='+currPath;
				}else{
					_this.$message.error({message: errorback});
				}
			},(errorback)=>{
				_this.dis=false;
				_this.$message.error({message: errorback});
			})
		 }, 
		
		typeChooseMore(e){//业务类型
			let typeNum = e.target.getAttribute('typeNum');
				this.businessType=[];
				if(this.sqkf!=''){
					this.businessType.push(this.sqkf);
				}
				if(this.shkf!=''){
					this.businessType.push(this.shkf);
				}
				if(this.dhkf!=''){
					this.businessType.push(this.dhkf);
				}
				if(typeNum=='sqkf'){
					if(this.sqkf==''){
						this.sqkf=1;
						this.businessType.push(this.sqkf);
					}else{
						for(var i = 0; i < this.businessType.length; i++){
							if(this.businessType[i] == this.sqkf){
								this.businessType.splice(i,1);
							}
						 }
						 if(this.businessType.length==0){
							 this.$message.error({message: '至少选择一项'});
							 this.businessType.push(this.sqkf);
							 this.businessType=this.businessType.toString();
						 }else{
							 this.sqkf='';
						 }
						 
					}
					
					this.businessType=this.businessType.toString();
					this.getProductInfo();
				}else if(typeNum=='shkf'){
					if(this.shkf==''){
						this.shkf=2;
						this.businessType.push(this.shkf);
					}else{
						for(var i = 0; i < this.businessType.length; i++){
							if(this.businessType[i] == this.shkf){
								this.businessType.splice(i,1);
							}
						 }
						if(this.businessType.length==0){
							 this.$message.error({message: '至少选择一项'});
							 this.businessType.push(this.shkf);
						}else{
							 this.shkf='';
						}
					}
					
					this.businessType=this.businessType.toString();
					this.getProductInfo();
				}else if(typeNum=='dhkf'){
					if(this.dhkf==''){
						this.dhkf=3;
						this.businessType.push(this.dhkf);
					}else{
						for(var i = 0; i < this.businessType.length; i++){
							if(this.businessType[i] == this.dhkf){
								this.businessType.splice(i,1);
							}
						 }
						if(this.businessType.length==0){
							 this.$message.error({message: '至少选择一项'});
							 this.businessType.push(this.dhkf);
						}else{
							 this.dhkf='';
						}
					}
					
					this.businessType=this.businessType.toString();
					this.getProductInfo();
				}
			
		},
		
		getProductInfo(){
			this.axios({
			    method: 'POST',
			    url:'/product/getProductInfo',
				params:{
					bussFlag:this.bussFlag,
					businessType:this.businessType,
				},
			}).then((res)=>{
					if(res.data.code==1000){
						this.productPrice = res.data.obj.price;
						this.pid = res.data.obj.pid;
						this.dis=false;
						this.buyBtn="立即购买";
						
					}else if(res.data.code==1002){
						this.pid=null;
						this.productPrice='my';
						this.dis=true;
						this.buyBtn="请咨询客服";
					}
			}).catch((err)=>{
				 this.$message.error({message: '获取数据失败'});
			})
		},
		
		runQq(){//QQ联系
			openConsult(this.qqNum);
		},
		runWx(){//微信联系
			if(this.wxNum==null){
				this.wxShow=false;
				this.$message('该业务员暂无微信');
			}else{
				this.wxShow=true;
			}
		},
		copy(){
			var clipboard = new Clipboard('#copyTxt', {
			    text: function () {
			        //return $('#copyValue').text();
			    }
			});
					
			clipboard.on('success', e => {  
				this.$message.success({message: '已复制成功，快去微信添加好友吧~~',customClass:'mzindex'});
				// 释放内存  
				clipboard.destroy()  
			})  
			clipboard.on('error', e => {  
				  // 不支持复制 
				   this.$message.error({message: '抱歉哦，复制失败请手动复制微信号~~',customClass:'mzindex'});
				  // 释放内存  
				  clipboard.destroy()  
			})  
			       
		},
	 },
	 created() {
		 let _this = this;
		getProductDetail(25,this.$route.params.pid,function(data){ //产品信息
			if(data.obj == "" || data.obj == null){
				_this.productPrice='my';
				_this.dis=true;
				_this.buyBtn="请咨询客服";
			}else{
				_this.productPrice=data.obj.price;
				_this.pid = data.obj.pid;
				_this.businessType = data.obj.businessType;
				var arr = _this.businessType.split(',');
				for(var i=0;i<arr.length;i++){
					if(arr[i]==1){
						_this.sqkf=arr1[i];
					}
					if(arr[i]==2){
						_this.shkf=arr1[i];
					}
					if(arr[i]==3){
						_this.dhkf=arr1[i];
					}
				}
			}
		},(errorback)=>{
			_this.$message.error({message: errorback});
		})
		
		getCustomerInfo(function(data){//业务员信息
			_this.qqNum=data.qq;
			_this.wxNum=data.wx;
			_this.phoneNum=data.phone;
			_this.wxPic=_this.rootUrl+data.wxPic;
		},()=>{
			_this.$message.error({message: '网络异常，请稍后重试'});
		})
		
	 },
   }
</script>